<template>
  <div v-show="!hidden" class="search-box">
    <div class="search-box-header">
      <AppCheckBox v-if="select" v-model="checkAll" :checked="checkAll" class="w6 text-lg">{{
        selectTitle
      }}</AppCheckBox>
      <slot name="header"></slot>
    </div>

    <div class="search-box-body">
      <slot name="body"></slot>
    </div>
  </div>
</template>

<script setup>
// eslint-disable-next-line
import { computed } from 'vue';

const props = defineProps({
  modelValue: {
    type: null,
    required: false,
    description: 'List data has checkbox, require if :select is TRUE',
  },
  select: {
    type: Boolean,
    default: false,
    description: 'Select all item in array list',
  },
  selectTitle: {
    type: String,
    default: '',
    require: false,
    description: 'Title for checkbox',
  },
  selectValue: {
    type: null,
    require: false,
    description: 'Value for checkbox',
  },
  hidden: {
    type: Boolean,
    require: false,
    default: false,
    description: 'Hidden when list data has length === 0',
  },
});

const emit = defineEmits(['update:modelValue', 'change-status']);

const checkAll = computed({
  set(newValue) {
    emit('update:modelValue', newValue);
    emit('change-status');
  },
  get() {
    return props.modelValue;
  },
});
</script>
